import { api } from '../apiClient';

/**
 * 결제 창구 — 콘솔 결제 화면 (#244)
 *
 * 금액은 서비스 서버가 주문을 만들 때 정했다. 이 화면은 금액을 보내지 않는다.
 */
export interface CheckoutOrder {
  order_id: string;
  order_name: string;
  service_name: string;
  amount: number;
  currency: string;
  status: 'pending' | 'paid' | 'failed' | 'expired';
  expires_at: string;
  return_url: string;
  toss_client_key: string | null;
  is_test_mode: boolean;
}

export const paymentOrderAPI = {
  get: (orderId: string): Promise<CheckoutOrder> =>
    api.get(`/payment/orders/${encodeURIComponent(orderId)}`).then((r) => r.data),

  confirm: (orderId: string, paymentKey: string): Promise<{ redirect_to: string }> =>
    api.post(`/payment/orders/${encodeURIComponent(orderId)}/confirm`, { payment_key: paymentKey })
      .then((r) => r.data),

  fail: (orderId: string, code: string, message: string): Promise<{ redirect_to: string }> =>
    api.post(`/payment/orders/${encodeURIComponent(orderId)}/fail`, { code, message })
      .then((r) => r.data),
};
